import get from 'lodash-es/get';
/**
 * Model to hold User data from identity
 */
import { IdentityAssessor, IdentityPerson } from '@reg/shared/model';

export class IdentityUser {
    public id: string = null;
    public floId: string = null;
    public person: IdentityPerson = null;
    public assessors: IdentityAssessor[] = [];

    constructor(id: string = null, floId: string = null) {
        this.id = id;
        this.floId = floId;
    }

    public clone(): IdentityUser {
        const clone: IdentityUser = new IdentityUser();
        clone.id = this.id;
        clone.floId = this.floId;
        clone.person = this.person && this.person.clone();

        if (this.assessors) {
            clone.assessors = [];

            this.assessors.forEach((a: IdentityAssessor) => {
                const assessor: IdentityAssessor = a.clone(false);
                assessor.user = this;
                clone.assessors.push(assessor);
            });
        }

        return clone;
    }

    /**
     * Serialize to a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'user';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.attributes.floId = this.floId.toString();

        return JSON.stringify(json);
    }

    /**
     * Deserialize from json api format
     */
    public deserialize(json: any, included: any[] = null): IdentityUser {
        const data: any = json['data'] || json;
        const attrs: any = data.attributes || [];
        included = included || json['included'] || [];

        this.id = data.id;
        this.floId = attrs.floId;

        // Fill Person from relationships if it exists
        const personId: string = get(data, 'relationships.person.data.id');
        const person: any = included.filter((i: any) => i['type'] === 'person' && i['id'] === personId)[0];

        if (person) {
            this.person = (new IdentityPerson()).deserialize(person, [], '');
        }

        const assessorList: any[] = get(data, 'relationships.assessors.data') || [];
        assessorList.forEach((x: any) => {
            const item: any = included.filter((i: any) => i.id === x.id)[0];

            if (item) {
                this.assessors.push((new IdentityAssessor()).deserialize(item, included, this));
            }
        });

        return this;
    }
}
